export const machineData = [
  "Drill Machine-xxxx1",
  "Drill Machine-xxxxxxxxxxxxxxxxxxx",
  "WEIDA VMC",
  "WALDRICH COBURG SURFACE GRINDING",
  "WMW SLIDEWAY GRINDING",
  "WMW SURFACE GRINDING",
  "VIKRAM LATHE",
  "MYSORE KIRLOSKAR LATHE",
  "HURON MILLING M/C",
  "BOEHRINGER TURNING CNC",
  "MIKRON-VC 1000 TNC 407",
  "MAS VR4 RADIAL",
  "HMT RADIAL DRILLING",

  "CSEPEL RADIAL DRILLING",
  "WALDRICH COBURG VMC",
  "TOS VMC",
  " PFEIFER HORIZONTAL BORING",
  "CNC BED TYPE MILLING M/C (BUTLER)",
  "INGERSOLL BOHLE VMC",
  "PINNACLE",
  "CNC DEEP HOLE DRILLING MACHINE (LOCH MAKE)",
  "CNC DEEP HOLE DRILLING MACHINE (HEGENGGHEIDT MAKE)",
  " BANDSAW MACHINE",

  "PUNJAB MAKE LATHE MACHINE",
  "TAPPING MACHINE",
  "SURFACE GRINDING MACHINE (CAMUT)",
  "Bench",
  "Johnford VMC 1 ",
  "Johnford VMC 2",
  "Press machine 100 ton",
  " EDM MACHINE",
  " WELDING M/C",

  "TEMPERATURE MACHINE",

  " Pedestal Fan No 1 ( PF 1)",
  "Pedestal Fan No 2 (PF 2)",
  " Pedestal Fan No 3 (PF 3)",
  "Pedestal Fan No 4 (PF 4)",
  "Pedestal Fan No 5 (PF 5)",

  "S ROCCO BORING",
  "Hartford 1",
  "Hartford 2",
  "CNC VTL",
  "Tos Boring machine",
  "Stama VMC",
];

export const toolListMilling = ["Side & Face Cutter", "EndMill", "Cutter Dia"];

export const toolListDrilling = [
  "Drill 1.0mm",
  "Drill 1.5mm",
  "Drill 2.0mm",
  "Drill 2.5mm",
  "Drill 3.0mm",
  "Drill 3.2mm",
  "Drill 3.3mm",
  "Drill 3.43mm",
  "Drill 3.5mm",
  "Drill 4.2mm",
  "Drill 6.8mm",
  "Drill 7.0mm",
  "Drill 7.5mm",
  "Drill 8.0mm",
  "Drill 8.5mm",
  "Drill 10.0mm",
  "Drill 10.5mm",
  "Drill 11.0mm",
  "Drill 11.5mm",
  "Drill 12.0mm",
  "Drill 12.5mm",
  "Drill 13.0mm",
  "Drill 13.5mm",
  "Drill 14.0mm",
  "Drill 14.5mm",
  "Drill 15.0mm",
  "Drill 15.5mm",
  "Drill 16.0mm",
  "Drill 16.5mm",
  "Drill 17.0mm",
  "Drill 17.5mm",
  "Drill 18.0mm",
  "Drill 18.5mm",
  "Drill 19.0mm",
  "Drill 19.5mm",
  "Drill 20.0mm",
  "Drill 20.5mm",
  "Drill 20.75mm",
  "Drill 21.0mm",
  "Drill 21.5mm",
  "Drill 22.0mm",
  "Drill 22.5mm",
  "Drill 22.25mm",
  "Drill 23.0mm",
  "Drill 24.0mm",
  "Drill 24.5mm",
  "Drill 25.0mm",
  "Drill 25.4mm(1'')",
  "Drill 25.5mm",
  "Drill 26.0mm",
  "Drill 26.5mm",
  "Drill 27.0mm",
  "Drill 27.75mm",
  "Drill 28.0mm",
  "Drill 28.5mm",
  "Drill 29.0mm",
  "Drill 29.5mm",
  "Drill 30.0mm",
  "Drill 30.2mm",
  "Drill 30.5mm",
  "Drill 31.0mm",
  "Drill 32.0mm",
  "Drill 32.6mm",
  "Drill 33.0mm",
  "Drill 34.0mm",
  "Drill 34.5mm",
  "Drill 37.0mm",
  "Drill 37.5mm",
  "Drill 38.0mm",
  "Drill 38.5mm",
  "Drill 39.5mm",
  "Drill 40.0mm",
  "Drill 42.0mm",
  "Drill 42.5mm",
  "Drill 43.5mm",
  "Drill 44.0mm",
  "Drill 45.0mm",
  "Drill 48.0mm",
  "Drill 56.0mm",
  "Drill 60.0mm",
  "Drill 11.0mm",
  "Drill 11.0mm",
  "Drill 12.0mm",
  "Drill 14.0mm",
  "Drill 18.0mm",
  "Drill 22.0mm",
  "Drill 23.0mm",
  "Drill 25.0mm",
  "Drill 30.0mm",
  "Drill 30.16mm",
  "Drill 30.5mm",
  "Drill 34.0mm",
  "Drill 40.5.0mm",
  "Drill 3/4''",
  "Drill 13/32",
  "Drill BS-5",
  "Drill BS-6",
  "Drill A4",
  "Drill BS-4 Long",
  "Drill BS-5 Long",
  "Drill BS-4",
  "UDrill 13.0mm",
  "UDrill 14mm",
  "UDrill 14.0mm",
  "UDrill 16.0mm",
  "UDrill 17.0mm",
  "UDrill 17.5mm",
  "UDrill 18.0mm",
  "UDrill 18x28mm",
  "UDrill 18.5mm",
  "UDrill 20.5mm",
  "UDrill 21mm",
  "UDrill 21.0mm",
  "UDrill 22.0mm",
  "UDrill 24.0mm",
  "UDrill 24.5x270mm",
  "UDrill 25.0mm",
  "UDrill 25x200mm",
  "UDrill 26mm",
  "UDrill 26.0mm",
  "UDrill 26.5mm",
  "UDrill 27mm",
  "UDrill 27.0mm",
  "UDrill 29.5mm",
  "UDrill 29x230mm",
  "UDrill 30.4mm",
  "UDrill 30x195mm",
  "UDrill 30x240mm",
  "UDrill 30x300mm",
  "UDrill 32.0mm",
  "UDrill 32x300mm",
  "UDrill 33 x 155mm",
  "UDrill 33 x 155mm",
  "UDrill 33 x 190mm",
  "UDrill 33 x 190mm",
  "UDrill 33.0mm",
  "UDrill 34.0mm",
  "UDrill 36x185mm",
  "UDrill 36x185mm",
  "UDrill 38mm",
  "UDrill 38mm",
  "UDrill 40.0mm",
  "UDrill 42.0mm",
  "UDrill 44mm",
  "UDrill 44.0mm",
  "UDrill 44/50mm",
  "UDrill 45.0mm",
  "UDrill 48.0mm",
  "UDrill 49.0mm",
  "UDrill 50.0mm",
  "UDrill 50x400mm",
  "UDrill 59.0mm",
  "UDrill 60.0mm",
];

export const toolListBoring = ["Boring Bar"];

export const toolListTapping = [
  "Tapping  M5x0.8 Roll Tap",
  "Tapping M6x1 Roll Tap",
  "Tapping M8x1.25  Roll Tap",
  "Tapping M10",
  "Tapping M10x1.0",
  "Tapping M10x1.25",
  "Tapping M10x1.5x200 L",
  "Tapping M12x1.0",
  "Tapping M12X1.75  SP.FL.TAP",
  "Tapping M14",
  "Tapping M14 - Bottam III",
  "Tapping M14 - Taper I",
  "Tapping M14x1.0",
  "Tapping M14x1.25",
  "Tapping M14x1.5",
  "Tapping M14x1.5 III",
  "Tapping M14x2",
  "Tapping M16",
  "Tapping M16x1.5",
  "Tapping M16x2",
  "Tapping M18x1.5",
  "Tapping M18X2.5",
  "Tapping M19x1.0",
  "Tapping M2.5x0.45",
  "Tapping M20",
  "Tapping M20x1.5",
  "Tapping M20X2",
  "Tapping M20X2.5",
  "Tapping M20X2.5",
  "Tapping M22x1.5",
  "Tapping M22x2.5",
  "Tapping M24",
  "Tapping M24x1.0",
  "Tapping M24x1.5",
  "Tapping M24x1.5",
  "Tapping M24X2",
  "Tapping M24X3",
  "Tapping M24X3",
  "Tapping M25x1.5",
  "Tapping M25x1.5",
  "Tapping M26x1.5",
  "Tapping M26x1.5",
  "Tapping M27X2",
  "Tapping M27X3",
  "Tapping M27x3",
  "Tapping M28x1.5",
  "Tapping M28X2",
  "Tapping M3 - Bottam III",
  "Tapping M3 - Taper I",
  "Tapping M3.5x0.6",
  "Tapping M30",
  "Tapping M30x1.5",
  "Tapping M30x1.5  L.H",
  "Tapping M30X2",
  "Tapping M30X3.5",
  "Tapping M30X3.5",
  "Tapping M33X2",
  "Tapping M33x3.5",
  "Tapping M33x3.5",
  "Tapping M36X1.5",
  "Tapping M36x2",
  "Tapping M36X4",
  "Tapping M36x4",
  "Tapping M39x2",
  "Tapping M39X4",
  "Tapping M3x0.5",
  "Tapping M4",
  "Tapping M4 - Bottam III",
  "Tapping M4 - Taper I",
  "Tapping M4.5x0.75",
  "Tapping M40X1.5",
  "Tapping M40X2",
  "Tapping M42X4.5",
  "Tapping M45X4.5",
  "Tapping M4x0.7 Roll Tap",
  "Tapping M5",
  "Tapping M5 - Bottam III",
  "Tapping M5 - Taper I",
  "Tapping M50x2",
  "Tapping M52X5",
  "Tapping M6",
  "Tapping M6x1",
  "Tapping M8",
  "Tapping M8x1.0",
];

export const processList = [
  "MACHINING",
  "TOP SIDE ROUGH MACHINING",
  "SECOND SIDE ROUGH MACHINING",
  "FIRST SIDE ROUGH MACHINING",
  "FINISH MACHINING",
  "TAP M-20",
  "TOP SIDE FINISH MACHINING",
  "SETTING",
  "SIDE ROUGH MACHINING",
  "SIDE FINISH MACHINING",
  "बॉटम मशिनिंग करणे.",
  "H7 BORE",
  "बोअरिंग करणे.",
  "SLOT MACHINING",
  "REAMING",
  "STEP MACHINING",
  "TOP SIDE GRINDING",
  "BOTTOM SIDE GRINDING",
  "SIDE GRINDING",
  "TAP M-3",
  "TAP M-4",
  "TAP M-5",
  "TAP M-6",
  "TAP M-8",
  "TAP M-10",
  "TAP M-12",
  "TAP M-14",
  "TAP M-16",
  "TAP M-18",
  "TAP M-24",
  "TAP M-30",
  "TAPPING M24X2",
  "GRINDING",
  "8H7",
  "12H7",
  "SLOT ROUGH MACHINING",
  "SLOT FINISH MACHINING",
  "डीबरिंग करणे.",
  "सेंटरिंग करणे.",
  "ड्रिलिंग करणे.",
  "IN PROCESS INSPECTION",
  "JOB UNLOADING",
  "TOTAL LENGTH MACHINING",
  "SPOT FACE",
  "FACE CUT",
  "BORE OD ROUGH MC",
  "रफ बोअरिंग करणे.",
  "TOP SIDE ROUGH MC",
  "बॉटम रफ मशिनिंग करणे.",
  "बॉटम फिनिश मशिनिंग करणे.",
  "BORE OD FIN MC",
  "TOP LMA MC",
  "SIDE MC ROUGH",
  "SIDE MC FIN",
  "TOP IN SIDE MC",
  "REF CUT",
  "TOP ROUGH MC",
  "TOP FIN MACHINING",
  "SEND TO GRINDING",
  "TOP SIDE PAD MC",
  "TOP MC",
  "PAD MC",
  "DRILLING",
  "Champer",
  "TAPPING",
  "Pointing",
  "Slide Mounting Angular Grinding",
  "Tailstock Mounting Angular Grinding",
  "STRESS RELIEVING",
  "Marking",
  "Finishing Operations (Dbr/Cln/Hand Tapping)",
  "Marking and Hand Drilling",

  "MACHINE CLEAN & UNWANTED MATERIAL RETURN",
  "ALL OPERATIONS DONE",
  "ALL SIZES CHECKED",
  "बॉटम फेस पॅरलल ब्लॉकवर रेस्ट करून ट्रू करून क्लॅम्प करणे.",
  "टॉप फेस पॅरलल ब्लॉकवर रेस्ट करून ट्रू करून क्लॅम्प करणे.",
  "बॉटम फेस स्क्रू जॅकवर रेस्ट करून ट्रू करून क्लॅम्प करणे.",
  "टॉप फेस स्क्रू जॅकवर रेस्ट करून ट्रू करून क्लॅम्प करणे.",
  "टॉप फेस रफ मिलिंग करणे.",
  "टॉप फेस फिनिश मिलिंग करणे.",
  "बॉटम फेस फिनिश मिलिंग करणे.",
  "बॉटम फेस रफ मिलिंग करणे.",
  "साईड फेस रफ मिलिंग करणे.",
  "साईड फेस फिनिश मिलिंग करणे.",
  "हाईट फिनिश करणे.",
  "विड्थ फिनिश मशिनिंग करणे.",
  "लेंग्थ फिनिश मशिनिंग करणे. ",
  "फेस व स्टेप मिलिंग करणे.",
  "फेस व स्लॉट मिलिंग करणे.",
  "स्लॉट मिलिंग करणे.",
  "पॉकेट मिलिंग करणे",
  "1st Setup operations",
  "2nd setup Operations",
  "3rd Setup Operations",
  "IN-PROCESS INSPECTION",
  "थिकनेस रफ मशिनिंग करणे.",
  "थिकनेस फिनिश मशिनिंग करणे.",
  "विड्थ रफ मशिनिंग करणे.",
  "लेंग्थ रफ मशिनिंग करणे.",
  "OPERATIONAL INSPECTION",
  "DIMENSIONAL INSPECTION",
  "BOTTOM ROUGH MACHINING",
  "TOP ROUGH MACHINING",
  "Thk Rough Machining",
  "Thk Finish Machining",
  "Machine cleaning",
  "Setting Material Action ",
];

export const idleCode = [
  { no: 1, name: "No Power (Electricity)" },
  { no: 2, name: "Drawing Issue" },
  { no: 3, name: "Weekly Off" },
  { no: 4, name: "Material Issue" },
  { no: 5, name: "No Crane" },
  { no: 6, name: "No Air" },
  { no: 7, name: "Stores - Collection of Tools/Drags/Instruments/Gauges etc" },
  { no: 8, name: "Minor Machine Breakdown" },
  { no: 9, name: "Waiting for dicision" },
  { no: 10, name: "Discountinue current load" },
  { no: 11, name: "Availability of Co worker load" },
  { no: 12, name: "Operator Absent/ Late mark" },
  { no: 13, name: "No Load/ No Plan" },
  { no: 14, name: "Rework during Operations" },
  { no: 15, name: "Planned Maintainance" },
  { no: 16, name: "Unskilled operator on machine" },
  { no: 17, name: "Use of Worm out tooling/ Tooling problem" },
  { no: 18, name: "Stores - Collection of Tools/Drags/Instruments/Gauges etc" },
  { no: 19, name: "Searching and collecting componenet to be loaded" },
  { no: 20, name: "Operator shifted for other work during operations" },
  { no: 21, name: "Operator not allocated" },
  { no: 22, name: "Process Deviation" },
  { no: 23, name: "Mentance Team Availability" },
  { no: 24, name: "Inspection on Machine" },
];
export const userName = [
  "Swapnil Khatate",
  "Ganesh Gore",
  "Fulchand Kadam",
  "Samir lole ",
  "Sunil Jawalkar",
  "Vishal Zende",
  "Lahu Khatate",
  "Changdev Kudale",
  "Prajwal  Khatate",
  "Saurabh Hole",
  "Kishor Urke",
  "Amit Kale",
  "Jagannath Raut",
  "Kamlesh Kumar",
  "Chetan Kadam",
  "Ganesh Raut",
  "Gurudas Kapure",
  "Santosh Pawar",
  "Nagesh Jagtap",
  "Dnyaneshwar Padalwar",
  "Arbaj Attar",
  "Mark Reddy",
  "Jagannath Avhad",
  "Aman Attar",
];
